import { ThemeOptions } from '@mui/material';

export const MuiButtonBase: ThemeOptions['components']['MuiButtonBase'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-focusVisible, &:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2
      },
      '&.MuiButton-outlined': {
        border: '1px solid'
      }
    })
  }
};
